import {IconButton, styled, useTheme} from '@mui/material'
import FormTextInput from 'components/Control/Form/FormTextInput'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'

const NoteInput = ({inputRef, control, formErrors, onClose, submit}) => {
    const theme = useTheme()

    return (
        <InputWrapper>
            <StyledFormInput
                name="Note"
                fullWidth
                height="65px"
                inputref={inputRef}
                control={control}
                rules={{
                    required: true,
                }}
                errors={formErrors}
            />
            <div>
                <StyledIconButton
                    onClick={submit}
                    color="primary"
                    bgColor={theme.palette.success.primary}>
                    <CheckIcon />
                </StyledIconButton>
                <StyledIconButton onClick={onClose} color="error">
                    <CloseIcon />
                </StyledIconButton>
            </div>
        </InputWrapper>
    )
}

export default NoteInput

const StyledIconButton = styled(IconButton)`
    background-color: ${({bgColor}) => bgColor};
    &:hover {
        background-color: ${({bgHoverColor}) => bgHoverColor};
    }
`

const StyledFormInput = styled(FormTextInput)`
    width: 50%;
`

const InputWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 24px;
`
